import ManagerAvatar from './ManagerAvatar';

// Pair of manager portraits with VS divider, optional storyline + projection.

export default function MatchupCard({
  label,
  home,
  away,
  storyline,
  projection,
  featured = false,
}) {
  const containerClass = featured
    ? 'bg-gradient-to-r from-bg-surface to-bg-elevated p-5 md:p-8 border-l-4 border-accent-gold overflow-hidden'
    : 'bg-bg-surface p-4 md:p-5 overflow-hidden';
  const nameClass = featured
    ? 'text-xl md:text-2xl font-black leading-none break-words'
    : 'text-base md:text-lg font-black leading-none break-words';

  return (
    <div data-testid="matchup-card" className={containerClass}>
      <div className="text-[9px] font-extrabold tracking-[0.25em] text-accent-gold mb-3 break-words">{label}</div>
      <div className="grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_48px_minmax(0,1fr)] md:grid-cols-[minmax(0,1fr)_60px_minmax(0,1fr)] gap-3 sm:gap-4 items-center">
        <div className="flex items-center gap-3 min-w-0">
          <ManagerAvatar name={home.name} size={featured ? 'md' : 'sm'} framed={featured} />
          <div className="min-w-0">
            <div className={nameClass}>{home.name.toUpperCase()}</div>
            {home.subtitle && <div className="text-[9px] text-ink-tertiary tracking-[0.15em] leading-tight break-words mt-1">{home.subtitle}</div>}
          </div>
        </div>
        <div className={`text-center font-black text-accent-gold border-y border-border/70 py-1 sm:border-0 sm:py-0 ${featured ? 'text-2xl md:text-3xl' : 'text-sm md:text-base'}`}>VS</div>
        <div className="flex items-center gap-3 min-w-0 sm:flex-row-reverse sm:text-right">
          <ManagerAvatar name={away.name} size={featured ? 'md' : 'sm'} framed={featured} />
          <div className="min-w-0">
            <div className={nameClass}>{away.name.toUpperCase()}</div>
            {away.subtitle && <div className="text-[9px] text-ink-tertiary tracking-[0.15em] leading-tight break-words mt-1">{away.subtitle}</div>}
          </div>
        </div>
      </div>
      {storyline && (
        <div className="text-xs italic text-ink-secondary mt-4 pt-3 border-t border-border leading-relaxed">{storyline}</div>
      )}
      {projection && (
        <div className="text-[9px] text-ink-tertiary tracking-[0.2em] mt-2.5">{projection}</div>
      )}
    </div>
  );
}
